export default __webpack_public_path__ + "static/media/floor-10.421b7442.jpg";